import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MarketplaceItem, MarketplaceState, initialMarketplaceState } from './state'

export const marketplaceSlice = createSlice({
  name: 'marketplace',
  initialState: initialMarketplaceState as MarketplaceState,
  reducers: {
    setMarketplaceLoading: (state: MarketplaceState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setMarketplaceItems: (state: MarketplaceState, action: PayloadAction<MarketplaceItem[]>) => {
      state.items = action.payload
    },
    setMarketplaceError: (state: MarketplaceState, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    clearMarketplace: (state: MarketplaceState) => {
      state.items = []
      state.error = undefined
      state.isLoading = false
    },
    addMarketplaceItem: (state: MarketplaceState, action: PayloadAction<MarketplaceItem>) => {
      // Check if item already exists to avoid duplicates
      const exists = state.items.some(item => item._id === action.payload._id)
      if (!exists) {
        state.items.push(action.payload)
      }
    },
    removeMarketplaceItem: (state: MarketplaceState, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item._id !== action.payload)
    }
  }
})

export const {
  setMarketplaceLoading,
  setMarketplaceItems,
  setMarketplaceError,
  clearMarketplace,
  addMarketplaceItem,
  removeMarketplaceItem,
} = marketplaceSlice.actions

export default marketplaceSlice.reducer


